import { NgModule } from '@angular/core';
import { SyncOrAsyncPipe } from './sync-or-async.pipe';

@NgModule({
  declarations: [SyncOrAsyncPipe],
  exports: [SyncOrAsyncPipe],
})
export class AccredibleSyncOrAsyncPipeModule {}
